import { render } from "./TarifaPresRegistro.vue?vue&type=template&id=aeb4cffe"
import script from "./TarifaPresRegistro.vue?vue&type=script&lang=js"
export * from "./TarifaPresRegistro.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__